import { Component, OnInit, ViewChild } from '@angular/core';
import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from '@almothafar/angular-signature-pad';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.css']
})
export class SignatureComponent implements OnInit {

  showSignature = false;
  isLoading = false;
  showSave = true;
  tandaTangan: string | undefined;
  @ViewChild('signature') public signaturePad:
    | SignaturePadComponent
    | undefined;

  signaturePadOptions: NgSignaturePadOptions = {
    // passed through to szimek/signature_pad constructor
    minWidth: 2,
    canvasWidth: 300,
    canvasHeight: 200,
  };

  constructor() { }

  ngOnInit(): void {
  }

  /** start signature **/
  clearSignature() {
    this.signaturePad?.clear();
    this.tandaTangan = '';
  }

  editSignature() {
    this.showSignature = true;
    this.showSave = false;
  }

  saveSignature() {
    if (!this.signaturePad?.isEmpty()) {
      this.tandaTangan = this.signaturePad?.toDataURL();
    }
    this.showSignature = false;
    this.showSave = true;
  }

  /** end of signature **/

}
